import * as http from "./http";
import {
  ApiResponse,
  Lead,
  Customer,
  PaginatedApiResponse,
  PartnerInfo,
  VehicleUserDetails,
  CreateLead,
  LeadDemographic,
  CreateVehicle,
  LeadQualityChange,
  ILeadBulkAssign,
  ListSort,
  ILeadAction,
  CreateScheduleATestDrive,
  CreateRequestACallbackt,
  CreateShowroomVisit,
  Lead360Data,
  Tag,
  ILeadActivity,
  IAddLeadActivityModel,
  IUpdateEventModel,
  ILeadEvent,
  CalendarApiResponse,
  ICalendarEventResponse,
  ICalendarEventListItem,
  ICancelReason,
  ILeadGridView,
  CancellationData,
  IMarkAsLost,
  Company,
  CreateInterestedProject,
} from "../models";
import ApiService from "./service";
import { Dict } from "../../models";
import { IEventCancelModel } from "../../../containers/calendar/components/event-cancel-form";
import { TimeReservationAPIModel } from "../../../containers/leads/components/activities/time-reservation-form";
import { ActivityCategory } from "../../../containers/requirement/components/props";

export class LeadService extends ApiService {
  public async createLead(data: CreateLead) {
    const url = `${this.apiDomain}/api/lead/`;

    const response = await http.post<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }
  public async bulkAssign(data: ILeadBulkAssign) {
    const url = `${this.apiDomain}/api/lead/bulk-assign`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async updateSocialMediaDetails(data: Customer, id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/social-media-details`;

    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async updateCompanySocialMediaDetails(data: Customer, id?: string) {
    const url = `${this.apiDomain}/api/company/${id}/social-media-details`;

    const response = await http.put<ApiResponse<Company>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async updatePreferredTimes(data: Customer, id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/preferred-times`;

    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async getLinkedLeads(id: string): Promise<ApiResponse<Lead[]>> {
    const url = `${this.apiDomain}/api/lead/${id}/linked-leads`;

    const response = await http.get<ApiResponse<Lead[]>>(url, this.store);

    return response?.data;
  }

  public async getLinkableLeads(id: string): Promise<ApiResponse<Lead[]>> {
    const url = `${this.apiDomain}/api/lead/${id}/linkable-leads`;

    const response = await http.get<ApiResponse<Lead[]>>(url, this.store);

    return response?.data;
  }

  public async linkLead(
    id: string,
    parentLeadId: string
  ): Promise<ApiResponse<Lead>> {
    const url = `${this.apiDomain}/api/lead/${id}/linked-leads`;

    const response = await http.post<ApiResponse<Lead>>(
      url,
      { parentLeadId },
      this.store
    );

    return response?.data;
  }

  public async getLeadActivities(
    id: string,
    status: "completed" | "planned",
    filter?: {
      page?: number;
      type: string;
    }
  ): Promise<PaginatedApiResponse<ILeadActivity>> {
    let url = `${this.apiDomain}/api/lead/${id}/activities?status=${status}`;
    if (
      filter?.type != null &&
      filter?.type !== undefined &&
      filter.type !== "All"
    ) {
      url += `&type=${filter?.type}`;
    }
    if (filter?.page != null) {
      url += `&page=${filter.page}`;
    }
    const response = await http.get<PaginatedApiResponse<ILeadActivity>>(
      url,
      this.store
    );

    return response?.data;
  }

  public async getAllLeadActivities(
    ids: string[],
    status: "completed" | "planned",
    filter?: {
      page: number;
      type: string;
    },
    type?: string,
    customerId?: string
  ): Promise<PaginatedApiResponse<ILeadActivity>> {
    const url = `${this.apiDomain}/api/activity/all`;
    const data: any = {
      status,
      // leadIds: ids,
      page: filter?.page,
    };
    if (type === "company") {
      data.companyId = ids[0];
    } else if(type === ActivityCategory.Property){
      data.propertyId = ids[0];
      data.activityCategory =type;
    } else if(type === ActivityCategory.Project){
      data.activityCategory =type;
      data.projectId = ids[0];
    }else{
      if(type === 'customer' && customerId){
        data.customerId = customerId
        data.customer360 = true
        data.leadIds = ids;
      }
      data.leadIds = ids;
    }

    if (filter?.type !== null && filter?.type !== undefined) {
      data.type = filter?.type;
    }
    const response = await http.post<PaginatedApiResponse<ILeadActivity>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async getActivities(leadId?: string) {
    const url = `${this.apiDomain}/api/activity/all`;
    const response = await http.post<ApiResponse<ILeadActivity[]>>(
      url,
      { leadId, avoidDefault: true, page: 1, perPage: 1000 },
      this.store
    );
    return response?.data?.data;
  }

  public async getCalandarEvents(
    data: {
      fromDate?: Date;
      toDate?: Date;
      assignedPersonIds?: string[];
      showroomIds?: string[];
    },
    listKey?: string
  ): Promise<CalendarApiResponse<ICalendarEventResponse>> {
    const url = `${this.apiDomain}/api/events/calendar-events`;
    if (listKey) {
      data = { ...data, list: listKey } as any;
    }
    const response = await http.post<
      CalendarApiResponse<ICalendarEventResponse>
    >(url, data, this.store);
    return response?.data;
  }

  public async getVehicleEvents(data: {
    fromDate?: Date;
    toDate?: Date;
    assignedPersonIds?: string[];
    vehicleIds?: string[];
  }): Promise<CalendarApiResponse<ICalendarEventResponse>> {
    const url = `${this.apiDomain}/api/events/calendar-events-vehicle`;
    const response = await http.post<
      CalendarApiResponse<ICalendarEventResponse>
    >(url, data, this.store);
    return response?.data;
  }

  public async addLeadActivity(
    activity: IAddLeadActivityModel
  ): Promise<ApiResponse<ILeadActivity[]>> {
    const url = `${this.apiDomain}/api/activity`;
    const response = await http.post<ApiResponse<ILeadActivity[]>>(
      url,
      activity,
      this.store
    );
    return response?.data;
  }

  public async addTimeReservation(
    activity: TimeReservationAPIModel
  ): Promise<ApiResponse<any>> {
    const url = `${this.apiDomain}/api/events/reserve-time`;
    const response = await http.post<ApiResponse<ILeadActivity[]>>(
      url,
      activity,
      this.store
    );
    return response?.data;
  }

  public async addVehicleTimeReservation(
    activity: TimeReservationAPIModel
  ): Promise<ApiResponse<any>> {
    const url = `${this.apiDomain}/api/events/vehicle-off-time`;
    const response = await http.post<ApiResponse<ILeadActivity[]>>(
      url,
      activity,
      this.store
    );
    return response?.data;
  }

  public async updateLeadActivity(
    eventId: string,
    activity: IUpdateEventModel
  ): Promise<ApiResponse<ILeadActivity[]>> {
    const url = `${this.apiDomain}/api/events/${eventId}/`;
    const response = await http.put<ApiResponse<ILeadActivity[]>>(
      url,
      activity,
      this.store
    );
    return response?.data;
  }

  public async getEventDetails(
    eventId: string
  ): Promise<ApiResponse<ILeadEvent>> {
    const url = `${this.apiDomain}/api/events/${eventId}/`;
    const response = await http.get<ApiResponse<ILeadEvent>>(url, this.store);
    return response?.data;
  }

  public async getActivityDetails(
    activityId: string
  ): Promise<ApiResponse<ILeadActivity>> {
    const url = `${this.apiDomain}/api/activity/${activityId}/`;
    const response = await http.get<ApiResponse<ILeadActivity>>(
      url,
      this.store
    );
    return response?.data;
  }

  public async markActivityAsDone(
    activityId: string,
    mileageIn?: string,
    mileageOut?: string
  ): Promise<ApiResponse<ILeadActivity[]>> {
    const url = `${this.apiDomain}/api/activity/${activityId}/mark-done`;

    const response = await http.put<ApiResponse<ILeadActivity[]>>(
      url,
      { mileageIn, mileageOut },
      this.store
    );

    return response?.data;
  }

  public async markActivityAsUnDone(
    activityId: string
  ): Promise<ApiResponse<ILeadActivity[]>> {
    const url = `${this.apiDomain}/api/activity/${activityId}/mark-undone`;

    const response = await http.put<ApiResponse<ILeadActivity[]>>(
      url,
      {},
      this.store
    );

    return response?.data;
  }

  public async markEventAsDone(
    eventId: string,
    mileageIn?: string,
    mileageOut?: string
  ): Promise<ApiResponse<ILeadActivity[]>> {
    const url = `${this.apiDomain}/api/events/${eventId}/mark-done`;

    const response = await http.put<ApiResponse<ILeadActivity[]>>(
      url,
      { mileageIn, mileageOut },
      this.store
    );

    return response?.data;
  }

  public async unlinkLead(id: string): Promise<ApiResponse<Lead>> {
    const url = `${this.apiDomain}/api/lead/${id}/linked-leads`;

    const response = await http.remove<ApiResponse<Lead>>(url, this.store);

    return response?.data;
  }

  public async updateVehicleDetails(data: VehicleUserDetails[], id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/vehicle-details`;

    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async updatePartnerInfo(data: PartnerInfo, id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/partner-info`;

    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async getLead(id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}`;

    const response = await http.get<ApiResponse<Lead>>(url, this.store);

    return response?.data;
  }
  public async getCustomer360(id: string) {
    const url = `${this.apiDomain}/api/lead-360/customer/${id}`;

    const response = await http.get<ApiResponse<Lead360Data>>(url, this.store);

    return response?.data;
  }
  public async getCompany360(id: string) {
    const url = `${this.apiDomain}/api/lead-360/company/${id}`;

    const response = await http.get<ApiResponse<Lead360Data>>(url, this.store);

    return response?.data;
  }

  public async getCancellationReasons() {
    const url = `${this.apiDomain}/api/events/cancellation-reasons`;

    const response = await http.get<ApiResponse<ICancelReason[]>>(
      url,
      this.store
    );

    return response?.data;
  }

  public async updateBuyingInfluences(data: any, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/buying-influences`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async updateCustomerAnswers(data: any, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/customer-answers`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async cancelEvent(eventId: string, data: IEventCancelModel) {
    const url = `${this.apiDomain}/api/events/${eventId}/cancel`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }
  public async getLeads(
    data: {
      page: number;
      search?: string;
      perPage: number;
      isDeal?: boolean;
      customerId?: string;
      applyVisibilityFilter?: boolean;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<Lead> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/lead/list`;

    const resposne = await http.post<PaginatedApiResponse<Lead>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  // lead-transfer-report
  public async getAssigneeChangeLeads(
    data: {
      page: number;
      search?: string;
      perPage: number;
      isDeal?: boolean;
      customerId?: string;
      applyVisibilityFilter?: boolean;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<Lead> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/lead/list/transfer-lead-report`;

    const resposne = await http.post<PaginatedApiResponse<Lead>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async getLeadsByAccess(
    data: {
      isDeal?: boolean;
      customerId?: string;
    } & ListSort &
      Dict
  ): Promise<ApiResponse<{ lead: Lead; lastAccessedDate: Date }[]>> {
    const url = `${this.apiDomain}/api/lead/by-access`;

    const resposne = await http.post<
      ApiResponse<{ lead: Lead; lastAccessedDate: Date }[]>
    >(url, data, this.store);
    return resposne.data;
  }

  public async getCalendarEventList(
    data: {
      page: number;
      search?: string;
      perPage: number;
      isDeal?: boolean;
    } & Dict
  ): Promise<
    PaginatedApiResponse<ICalendarEventListItem> & { lastUpdatedAt: Date }
  > {
    const url = `${this.apiDomain}/api/events/calendar-events-list?page=${data.page}&perPage=${data.perPage}`;

    const resposne = await http.post<
      PaginatedApiResponse<ICalendarEventListItem>
    >(url, data, this.store);
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async downloadCalendarEventList(
    data: {
      search?: string;
      isDeal?: boolean;
    } & Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/events/calendar-events-list/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      "application/application/vnd.openxmlformats",
      `calendar-events-list-${new Date()}.xlsx`
    );
  }

  public async downloadLeads(
    data: {
      search?: string;
      columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & ListSort &
      Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/lead/list/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      "application/application/vnd.openxmlformats",
      `Leads-${new Date()}.xlsx`
    );
  }

  public async downloadOpportunities(
    data: {
      search?: string;
      columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & ListSort &
      Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/lead/list/opportunity/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      "application/application/vnd.openxmlformats",
      `Leads-${new Date()}.xlsx`
    );
  }

  public async downloadLeadTransferReport(
    data: {
      search?: string;
      columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & ListSort &
      Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/lead/transfer-lead-report/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      "application/application/vnd.openxmlformats",
      `Leads-${new Date()}.xlsx`
    );
  }

  public async updateWorkExperiences(data: Customer, id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/work-experiences`;

    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async syncAutoLine(customerId: string) {
    const url = `${this.apiDomain}/api/customer/${customerId}/autoline/sync`;

    const response = await http.put<ApiResponse<Customer>>(url, {}, this.store);

    return response?.data;
  }

  public async cancelOrder(id: string, data: CancellationData) {
    const url = `${this.apiDomain}/api/configuration/${id}/cancel`;

    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async resetWorkExperiences(id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/work-experiences`;

    const response = await http.remove<ApiResponse<Customer>>(url, this.store);

    return response?.data;
  }

  public async updateDocumentsDetails(data: Customer, id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/documents`;

    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async updateDemographics(data: LeadDemographic, id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/demographics`;

    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async updateCompanyDemographics(data: Company, id: string) {
    const url = `${this.apiDomain}/api/company/${id}`;

    const response = await http.put<ApiResponse<Company>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async assignCompanySalesPerson(data: Company, id?: string) {
    const url = `${this.apiDomain}/api/company/${id}`;

    const response = await http.put<ApiResponse<Company>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async assignCrmAgent(
    crmAgentId: string,
    id?: string,
    crmChangeReasonId?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${id}/crm-agent`;

    const response = await http.put<ApiResponse<Lead>>(
      url,
      { crmAgentId, crmChangeReasonId },
      this.store
    );

    return response?.data;
  }

  public async assignLeadAssigneeHead(
    LeadAssigneeHeadId: string,
    id?: string,
    LeadAssigneeHeadChangeReasonId?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${id}/lead-assignee-head`;

    const response = await http.put<ApiResponse<Lead>>(
      url,
      { cityHeadId  :LeadAssigneeHeadId, LeadAssigneeHeadChangeReasonId },
      this.store
    );

    return response?.data;
  }

  public async updateAssignee(
    id: string,
    body:{leadManagerId?: string, groupManagerId?: string ,telecallerId?: string ,intercityUserId?: string , type?: string, LeadAssigneeHeadChangeReasonId?: string},
  ) {
    const url = `${this.apiDomain}/api/lead/${id}/update-assignee`;
    const response = await http.post<ApiResponse<Lead>>(
      url,
      {...body},
      this.store
    );

    return response?.data;
  }

  public async assignSalesPerson(
    data: {
      salesPersonId: string;
      customerReqSalesPerson: boolean;
      salesChangeReasonId?: string;
    },
    id?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${id}/sales-person`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async addVehicle(data: CreateVehicle, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/add-vehicle`;

    const response = await http.post<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async updateVehicle(data: CreateVehicle, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/vehicle`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async addInterestedProject(
    data: CreateInterestedProject,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${id}/add-interested-project`;

    const response = await http.post<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async updateInterestedProject(
    data: CreateInterestedProject,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${id}/update-interested-project`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async setVehicleAsPrimary(id?: string, vehicleId?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/set-primary-vehicle`;

    const response = await http.put<ApiResponse<Lead>>(
      url,
      {
        vehicleId,
        isPrimary: true,
      },
      this.store
    );

    return response?.data;
  }

  public async updateLeadQuality(data: LeadQualityChange, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/lead-quality`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async getLeadAction(id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/lead-actions`;

    const response = await http.get<ApiResponse<ILeadAction[]>>(
      url,
      this.store
    );

    return response?.data;
  }

  public async scheduleTestDrive(
    data: CreateScheduleATestDrive,
    leadId?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${leadId}/schedule-test-drive`;

    const response = await http.post<ApiResponse<ILeadAction>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async scheduleShowroomVisit(
    data: CreateShowroomVisit,
    leadId?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${leadId}/schedule-showroom-visit`;

    const response = await http.post<ApiResponse<ILeadAction>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async requestCallBack(data: CreateRequestACallbackt, leadId?: string) {
    const url = `${this.apiDomain}/api/lead/${leadId}/request-call-back`;

    const response = await http.post<ApiResponse<ILeadAction>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async convertAsEnquiry(status: string, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/toggle-deal`;
    const response = await http.put<ApiResponse<Lead>>(
      url,
      { status },
      this.store
    );

    return response?.data;
  }
  public async deleteLead(id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}`;
    const response = await http.remove<ApiResponse<Lead>>(url, this.store);

    return response?.data;
  }

  public async bulkDelete(data: ILeadBulkAssign) {
    const url = `${this.apiDomain}/api/lead/bulk-delete`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async convertAsVSLEnquiry(
    status: string,
    id?: string,
    quality?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${id}/vsl-toggle-deal`;
    const response = await http.put<ApiResponse<Lead>>(
      url,
      { status, quality },
      this.store
    );

    return response?.data;
  }

  public async updateLead(data: CreateLead, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/lead-settings`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async archiveLead(isArchived: boolean, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/archive-lead`;

    const response = await http.post<ApiResponse<Lead>>(url, { isArchived }, this.store);

    return response?.data;
  }

  public async updateTags(data: Tag, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/map-tags`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }
  public async updateLeadTitle(title?: string, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/title`;
    const response = await http.put<ApiResponse<Lead>>(
      url,
      {
        title,
      },
      this.store
    );

    return response?.data;
  }

  public async updateSetClosingDate(date: Date, id?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/set-closing-date`;

    const response = await http.put<ApiResponse<Lead>>(
      url,
      {
        expectedClosingDate: date,
      },
      this.store
    );

    return response?.data;
  }

  public async updateShowroom(id?: string, showroomId?: string) {
    const url = `${this.apiDomain}/api/lead/${id}/showroom`;

    const response = await http.put<ApiResponse<Lead>>(
      url,
      {
        showroomId,
      },
      this.store
    );

    return response?.data;
  }

  public async markAsLost(id: string, data: IMarkAsLost) {
    const url = `${this.apiDomain}/api/lead/${id}/mark-lost`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async leadGroupedByStages(
    data: {
      page: number;
      search?: string;
      perPage: number;
      customerId?: string;
    } & Dict
  ): Promise<PaginatedApiResponse<ILeadGridView[]> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/lead/grouped-by-stages`;

    const resposne = await http.post<PaginatedApiResponse<ILeadGridView[]>>(
      url,
      data,
      this.store
    );

    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async getLeadsGroupedByStagesDownload(
    data: {
      search?: string;
      columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & ListSort &
      Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/lead/grouped-by-stages/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      "application/application/vnd.openxmlformats",
      `Leads-${new Date()}.xlsx`
    );
  }

  public async getAllActivities(
    id: string,
    filter?: {
      page?: number;
      type: string;
    }
  ): Promise<ILeadActivity[]> {
    let url = `${this.apiDomain}/api/lead/${id}/activities`;
    if (
      filter?.type != null &&
      filter?.type !== undefined &&
      filter.type !== "All"
    ) {
      url += `&type=${filter?.type}`;
    }
    if (filter?.page != null) {
      url += `&page=${filter.page}`;
    }
    const response = await http.get<PaginatedApiResponse<ILeadActivity>>(
      url,
      this.store
    );

    return response?.data?.data;
  }
  public async getLeadLostRequests(
    data: {
      page: number;
      search?: string;
      perPage: number;
      isDeal?: boolean;
      customerId?: string;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<Lead> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/lead/lead-lost-requests`;

    const resposne = await http.post<PaginatedApiResponse<Lead>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }
  public async acceptMarkAsLost(id: string, data: { comment?: string }) {
    const url = `${this.apiDomain}/api/lead/${id}/approve-lost-request`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }
  public async rejectMarkAsLost(id: string, data: { comment?: string }) {
    const url = `${this.apiDomain}/api/lead/${id}/reject-lost-request`;

    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);

    return response?.data;
  }

  public async getAllTags(): Promise<string[]> {
    const url = `${this.apiDomain}/api/lead/lead-tags`;

    const response = await http.get<ApiResponse<string[]>>(url, this.store);

    return response?.data?.data;
  }

  async downloadTestDriveForm(activityId: string) {
    const url = `${this.apiDomain}/api/lead/${activityId}/download/pdf`;
    const reponse = await http.download(url, this.store);
    http.saveDownloadedFile(
      reponse.data,
      "application/pdf",
      `Test-Drive-Form.pdf`
    );
    return;
  }

  public async getFollowUpList(
    data: {
      page: number;
      search?: string;
      perPage: number;
    } & Dict
  ): Promise<
    PaginatedApiResponse<ICalendarEventListItem> & { lastUpdatedAt: Date }
  > {
    const url = `${this.apiDomain}/api/activity/follow-up?page=${data.page}&perPage=${data.perPage}`;

    const resposne = await http.post<
      PaginatedApiResponse<ICalendarEventListItem>
    >(url, data, this.store);
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async getAppointmentTime(
    showroomCode: string
  ): Promise<ICalendarEventListItem[]> {
    const url = `${this.apiDomain}/api/auth/appointment-time/${showroomCode}`;

    const resposne = await http.get<ApiResponse<ICalendarEventListItem[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async inititateTestDrive(
    activityId: string
  ): Promise<ApiResponse<ILeadActivity[]>> {
    const url = `${this.apiDomain}/api/activity/${activityId}/initiate-testdrive`;

    const response = await http.put<ApiResponse<ILeadActivity[]>>(
      url,
      {},
      this.store
    );

    return response?.data;
  }

  public async blockingCustomer(data: Customer, id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/block`;

    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async unBlockingCustomer(id?: string) {
    const url = `${this.apiDomain}/api/customer/${id}/unblock`;

    const response = await http.put<ApiResponse<Customer>>(url, {}, this.store);

    return response?.data;
  }

  public async updateCompanyUsers(
    addUsers: string[],
    removeUsers: string[],
    id?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${id}/update-company-users`;
    const response = await http.post<ApiResponse<Lead>>(
      url,
      { addUsers, removeUsers },
      this.store
    );

    return response?.data;
  }

  public async updateUserInfluence(
    data: {
      influenceId: string;
      userId: string;
    },
    id?: string
  ) {
    const url = `${this.apiDomain}/api/lead/${id}/user-influence`;
    const response = await http.put<ApiResponse<Customer>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async assignCompanyToLead(
    companyId: string,
    contactIds: string[],
    customerId:string,
    leadId: string
  ) {
    const url = `${this.apiDomain}/api/lead/${leadId}/assign-company`;
    const response = await http.post<ApiResponse<Lead>>(
      url,
      { companyId, contactIds, customerId },
      this.store
    );

    return response?.data;
  }

  public async mergeLeads( mergingLeadIds: string[], leadId:string) {
    const url = `${this.apiDomain}/api/lead/${leadId}/merge-leads`;

    const response = await http.put<ApiResponse<Lead>>(url, { mergingLeadIds }, this.store);

    return response?.data;
  }

}
